<template>
  <div class="errors-not-found-view">
    <h1>
      {{$t('titles.notFound')}}
    </h1>
    <alert-box type="info" icon="info">
      {{$t('hints.notFound')}}
    </alert-box>
    <link-button v-if="referrer" :to="{ path: referrer }" icon="refresh">
      {{$t('actions.retry')}}
    </link-button>
  </div>
</template>

<script>
import AlertBox from '@/components/AlertBox';
import View from '@/mixins/View';

export default {
  name: 'errors-not-found-view',
  mixins: [View],
  components: {
    AlertBox,
  },
  computed: {
    referrer() {
      return this.$route.query.from;
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          retry: 'Erneut versuchen',
        },
        titles: {
          notFound: 'Seite nicht gefunden',
        },
        hints: {
          notFound: `Die angeforderte Seite konnte nicht gefunden werden.
                     Möglicherweise wurde sie verschoben oder gänzlich
                     entfernt. Bitte versuch es später erneut oder wende dich
                     an einen Administrator.`,
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// NotFoundView.vue?60020578